import { produce } from 'immer';
import { inject, Injectable } from '@angular/core';
import type { StateContext } from '@ngxs/store';
import { Action, State } from '@ngxs/store';
import { APP_STATE_TOKEN } from './app-state.token';
import { RemoveSplashAction } from './action/remove-splash.action';
import type { AppStateModel } from './app-state.model';
import { DOCUMENT } from '@angular/common';
import { isNil } from '@pct-ts/typeguard';

@State<AppStateModel>({
  name: APP_STATE_TOKEN,
  defaults: produce(
    {} as AppStateModel,
    () =>
      ({
        showSplash: true,
        loading: true,
      }) satisfies AppStateModel,
  ),
})
@Injectable()
export class AppState {
  readonly #document = inject(DOCUMENT);

  @Action(RemoveSplashAction)
  removeSplash({ setState }: StateContext<AppStateModel>): Promise<void> {
    return new Promise<void>(resolve => {
      const splashElement = this.#document.getElementById('splash');
      if (!isNil(splashElement)) {
        splashElement.classList.add('init_done');
        setTimeout(() => {
          setState(
            produce(draft => {
              draft.showSplash = false;
              draft.loading = false;
            }),
          );
          splashElement.remove();
          resolve();
        }, 2000);
      }
    });
  }
}
